var projectMap = [
    ['huaban.com', 'hb_web'],
    ['gaoding.art', 'gaoding_art_web'],
    ['insmind.com', 'insmind_web'],
    ['gaoding.com', 'gd_gdesign_web']
];
export default (function () {
    var host = window.location.host;
    for (var i = 0; i < projectMap.length; i++) {
        var _a = projectMap[i], domain = _a[0], project = _a[1];
        if (host.indexOf(domain) > -1) {
            return project;
        }
    }
});
